var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("v-icon-" + _vm.icon),_vm._g({directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip
  }),expression:"{\n    content: tooltip\n  }"}],tag:"component",class:_vm.classes,style:(_vm.styles)},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }